// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import CreateNewPartnerTypeForm from '../create-new-partner-type-form';

//


// ----------------------------------------------------------------------

export default function CreateNewPartnerTypeView() {
    const settings = useSettingsContext();

    return (
        <Container maxWidth={settings.themeStretch ? false : 'lg'}>
            <CustomBreadcrumbs
                heading="Create Partner Type"
                links={[
                    {
                        name: 'Dashboard',
                        href: paths.dashboard.driverReview.root,
                    },
                    {
                        name: 'Partner Type',
                        href: paths.dashboard.partners.root,
                    },
                    { name: 'Add Partner Type' },
                ]}
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            />
            <CreateNewPartnerTypeForm isCreate />
        </Container>
    );
}

